<template>
  <CardItem v-if="thankyouScreen" :show-top-bar="false">
    <div class="flex flex-grow items-center justify-center">
      <TextTitle>
        <template #icon>
          <ik-image
              v-if="thankyouScreen.image.type === 'custom' && thankyouScreen.image.src"
              :src="thankyouScreen.image.src | parseImgUrl"
              style="max-width: 50px; height: 50px;"
              class="w-full object-cover select-none pointer-events-none"
              alt="Thank you screen image"
          />
          <a-icon
              v-else-if="thankyouScreen.image.type === 'default' || (showBranding && thankyouScreen.image.type === 'custom')"
              type="check-circle"
          />
        </template>
        {{ thankyouScreen.title ? thankyouScreen.title : defaultThankyou.title }}
        <template #description>
          <TextCollapsed
              :title="thankyouScreen.description"
              :max-length="300"
          />
        </template>
      </TextTitle>
    </div>
    <template #button>
      <a
          v-if="showButton"
          :href="thankyouScreen.button.link"
          target="_parent">
        <a-button
            type="primary"
            size="large"
            class="btn-action-primary"
            :style="[buttonBgColor, buttonTextColor]">
          {{ thankyouScreen.button.text }}
        </a-button>
      </a>
    </template>
  </CardItem>
</template>

<script>
import {mapGetters} from "vuex";
import {parseImgUrl, redirect} from "../../helpers/fns";
import CardItem from "../CardItem";
import themeMixin from "../../mixins/theme.mixin";
import TextCollapsed from "../TextCollapsed";
import TextTitle from "../TextTitle";

export default {
  name: "ScreenThankyou",
  props: {
    thankyouId: {
      type: String,
      default: null,
    },
  },
  filters: {parseImgUrl},
  mixins: [themeMixin],
  components: {CardItem, TextCollapsed, TextTitle},
  mounted() {
    if (
        this.thankyouScreen?.redirect?.isActive &&
        this.thankyouScreen?.redirect?.link
    ) {
      redirect(this.thankyouScreen?.redirect?.link);
    }
  },
  data() {
    return {
      defaultThankyou: {
        title: "Thank you!",
        description: "Your responses have been submitted successfully.",
        button: {},
        image: {
          type: "default",
        },
      },
    }
  },
  computed: {
    ...mapGetters(["survey", "showBranding"]),
    thankyouScreen: function () {
      const thankyou = this.survey.thankyouScreens.find(t => t._id === this.thankyouId) || this.survey.thankyouScreens[0]
      return thankyou?.isActive ? thankyou : this.defaultThankyou
    },
    showButton: function () {
      return this.thankyouScreen.button?.isActive && this.thankyouScreen.button?.link && this.thankyouScreen.button?.text
    },
  },
}
</script>

<style lang="less" scoped>

</style>
